import React from 'react';
import { useGetUserSessionInfoQuery } from '../redux-modules/service';
import SessionContext from '../contexts/SessionContext';

export default function SessionContainer({ children }: { children: React.ReactNode }) {
  const {
    data: session,
    isLoading,
    isFetching,
  } = useGetUserSessionInfoQuery({});
  if (isLoading || isFetching) {
    return null;
  }

  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
}
